// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "overview-a5b6df21/chunk-" + {"10": "3da498fd843cc5a6","311": "cdb7b741ef647d10","410": "65ba487f65efc8f0",}[chunkId] + ".js"
}